import { createFileRoute } from "@tanstack/react-router";
import { FunilCursoPage } from "@/components/funis/FunilCursoPage";
import { FUNIS } from "@/lib/funis/config";

const cfg = FUNIS["funil-lca"];

export const Route = createFileRoute("/funil-lca")({
  head: () => ({
    meta: [
      { title: "Curso Gratuito: Reabilitação do LCA" },
      { name: "description", content: "Curso online e gratuito de Reabilitação do LCA. Aulas gravadas, com certificado de 5h e baseado em evidências. Inscreva-se agora." },
      { property: "og:title", content: "Curso Gratuito: Reabilitação do LCA" },
      { property: "og:description", content: "Anatomia, exame clínico, pós-operatório e retorno esportivo na RLCA. Curso 100% gratuito, online, com certificado." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://fisioemortopedia.com.br/funil-lca" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Curso Gratuito: Reabilitação do LCA" },
      { name: "twitter:description", content: "Curso 100% gratuito, online, com certificado de 5h." },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/funil-lca" }],
  }),
  component: () => <FunilCursoPage cfg={cfg} />,
});
